import { Navigate, RouteObject } from "react-router";
import { SettingsPage } from "./settings";
import { FAQsPage } from "./FAQ";
import { Locations } from "./locations";
import { EncountersSettings } from "./encounters";
import { PatientDetailsSettings } from "./patientDetails";
import { VisitDetailsSettings } from "./visitDetails";
import { TaskDefinitionsSettings } from "./taskDefinitions/TaskDefinitions";
import { I18nSettings } from "./i18n/I18nSettings";
import { ComplaintCodesSettings } from "./complaintCodes/ComplaintCodes";
import { ClinicianIdsSettings } from "./clinicianIds/ClinicianIdsSettings";
import { SchedulerSettings } from "./scheduler";
import { IntegrationSettings } from "./integration/IntegrationSettings";
import {
  ExternalRegisterImportFlow,
  ExternalRegisterImportRouteContent,
} from "./externalRegister/import/ExternalRegisterImport";
import { ExternalRegisterAdminView } from "./externalRegister/adminView/ExternalRegisterAdminView";
import { ExternalRegisterImportHistoryPage } from "./externalRegister/history/ExternalRegisterImportHistoryPage";
import { ExternalRegisterLandingPage } from "./externalRegister/ExternalRegisterLandingPage";
import { ExternalRegisterSettingsAdminGuard } from "./externalRegister/ExternalRegisterSettingsAdminGuard";
import {
  EXTERNAL_REGISTER_ROUTE_SEGMENTS,
  EXTERNAL_REGISTER_SETTINGS_ROUTES,
} from "./externalRegister/externalRegisterRoutes";

export const settingRoutes: RouteObject = {
  path: "settings",
  element: <SettingsPage />,
  children: [
    {
      index: true,
      element: <Navigate to="/settings/patient-details" />,
    },
    {
      path: "patient-details",
      element: <PatientDetailsSettings />,
    },
    {
      path: "locations",
      element: <Locations />,
    },
    {
      path: "encounters",
      element: <EncountersSettings />,
    },
    {
      path: "task-definitions",
      element: <TaskDefinitionsSettings />,
    },
    {
      path: "visit-details",
      element: <VisitDetailsSettings />,
    },
    {
      path: "i18n",
      element: <I18nSettings />,
    },
    {
      path: "faqs",
      element: <FAQsPage />,
    },
    {
      path: "complaint-codes",
      element: <ComplaintCodesSettings />,
    },
    {
      path: "clinician-ids",
      element: <ClinicianIdsSettings />,
    },
    {
      path: "scheduler",
      element: <SchedulerSettings />,
    },
    {
      path: "integration",
      element: <IntegrationSettings />,
    },
    {
      path: EXTERNAL_REGISTER_ROUTE_SEGMENTS.root,
      element: <ExternalRegisterSettingsAdminGuard />,
      children: [
        {
          index: true,
          element: <ExternalRegisterLandingPage />,
        },
        {
          element: <ExternalRegisterImportFlow />,
          children: [
            {
              path: EXTERNAL_REGISTER_ROUTE_SEGMENTS.import,
              element: <ExternalRegisterImportRouteContent />,
            },
            {
              path: EXTERNAL_REGISTER_ROUTE_SEGMENTS.importHistory,
              element: <ExternalRegisterImportHistoryPage />,
            },
          ],
        },
        {
          path: EXTERNAL_REGISTER_ROUTE_SEGMENTS.admin,
          element: <ExternalRegisterAdminView />,
        },
      ],
    },
    {
      path: EXTERNAL_REGISTER_ROUTE_SEGMENTS.legacyImportHistory,
      element: <Navigate to={EXTERNAL_REGISTER_SETTINGS_ROUTES.importHistory} replace />,
    },
    {
      path: EXTERNAL_REGISTER_ROUTE_SEGMENTS.legacyImport,
      element: <Navigate to={EXTERNAL_REGISTER_SETTINGS_ROUTES.import} replace />,
    },
  ],
};
